<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="d-flex content-action align-items-center">
                <div class="d-flex align-items-center text-nowrap">
                    <b-button variant="outline-primary" @click="openCreateModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">Thêm trạm</span>
                    </b-button>
                </div>
            </div>
            <b-table
                class="mt-2"
                striped
                hover
                :items="items"
                :fields="fields"
                show-empty
                :current-page="currentPage"
                :per-page="CONSTANTS.ITEM_PER_PAGE"
            >
                <template #cell(index)="data">{{
                    (currentPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
                }}</template>
                <template v-slot:cell(userId)="row">
                    <span>{{ userName[row.value] }}</span>
                </template>
                <template #cell(date)="data">
                    <span>{{ data.value.split('-').join('/') }}</span>
                </template>
                <template #cell(createdAt)="data">
                    <span>{{ data.value | formatDateTime }}</span>
                </template>
                <template #cell(actions)="row">
                    <b-button
                        variant="primary"
                        class="mr-1 min-width-none"
                        @click="showUpdateModal(row.item.id)"
                        v-b-tooltip.hover
                        :title="$t('common.edit')"
                    >
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button
                        variant="danger"
                        @click="confirmDelete(row.item.id)"
                        v-b-tooltip.hover
                        class="min-width-none"
                        :title="$t('common.delete')"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>Không có bản ghi nào</span>
                    </div>
                </template>
            </b-table>
            <div v-if="countRow > CONSTANTS.ITEM_PER_PAGE" class="my-1">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="countRow"
                    :per-page="CONSTANTS.ITEM_PER_PAGE"
                    :hide-goto-end-buttons="true"
                    :prev-text="$t('common.prevPage')"
                    :next-text="$t('common.nextPage')"
                    class="my-0"
                    align="center"
                />
            </div>
        </div>

        <!-- Create/Edit Info -->
        <b-modal
            ref="createOrUpdateModal"
            :ok-title="`${itemInfo.id ? $t('common.update') : $t('common.create')}`"
            :title="`${itemInfo.id ? 'Cập nhật thông tin trạm' : 'Tạo mới trạm'}`"
            :cancel-title="$t('common.cancel')"
            @ok="handleCreateOk"
            no-close-on-esc
            no-close-on-backdrop
        >
            <b-form-group :label="$t('common.name')">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.name"
                    v-validate="'required'"
                    :placeholder="$t('common.name')"
                    name="name"
                    :data-vv-as="$t('common.name')"
                />
                <div v-show="errors.has('name')" class="validation-message text-danger">
                    {{ errors.first('name') }}
                </div>
            </b-form-group>
            <b-form-group :label="$t('common.description')">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.description"
                    v-validate="'required'"
                    :placeholder="$t('common.description')"
                    name="description"
                    :data-vv-as="$t('common.description')"
                />
                <div v-show="errors.has('description')" class="validation-message text-danger">
                    {{ errors.first('description') }}
                </div>
            </b-form-group>
            <b-form-group label="Mã trạm">
                <b-form-input placeholder="Mã trạm" v-model="itemInfo.code" />
            </b-form-group>
            <b-form-group label="Kinh độ">
                <b-form-input placeholder="Kinh độ" v-model="itemInfo.long" />
            </b-form-group>
            <b-form-group label="Vĩ độ">
                <b-form-input placeholder="Vĩ độ" v-model="itemInfo.lat" />
            </b-form-group>
            <div v-if="itemInfo.code.includes('F01')">
                <b-form-group label="Mực nước cấp III">
                    <b-form-input
                        maxlength="255"
                        v-model="itemInfo.warningLevel3"
                        placeholder="Nhập giá trị"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Mực nước cấp II">
                    <b-form-input
                        maxlength="255"
                        v-model="itemInfo.warningLevel2"
                        placeholder="Nhập giá trị"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Mực nước cấp I">
                    <b-form-input
                        maxlength="255"
                        v-model="itemInfo.warningLevel1"
                        placeholder="Nhập giá trị"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Mực nước thấp">
                    <b-form-input
                        maxlength="255"
                        v-model="itemInfo.configParams.warningLowWater"
                        placeholder="Nhập giá trị"
                    ></b-form-input>
                </b-form-group>
            </div>
            <b-form-group label="Cú pháp kết nối">
                <code>{{ stationScript(itemInfo.code) }}</code>
            </b-form-group>
        </b-modal>

        <!-- Confirm Delete -->
        <b-modal
            ref="deleteModal"
            :title="$t('common.confirmation')"
            no-close-on-esc
            no-close-on-backdrop
            :ok-title="$t('common.delete')"
            :cancel-title="$t('common.cancel')"
            ok-variant="danger"
            @ok="onDelete"
            >Bạn có chắc chắn muốn xoá trạm này?</b-modal
        >
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CONSTANTS from '@/constants';
export default {
    mounted: function () {
        this.$nextTick(function () {
            this.getList();
            this.getListUsers();
        });
    },
    computed: {
        ...mapState({
            items: (state) => state.station.items,
            item: (state) => state.station.item,
            listUsers: (state) => state.user.users
        }),
        countRow() {
            return this.items.length;
        },
        userName() {
            const user = {};
            this.listUsers.forEach((element) => {
                user[element.id] = element.name;
            });
            return user;
        }
    },
    data() {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                { tdClass: 'align-middle', key: 'name', label: this.$i18n.t('common.name') },
                {
                    tdClass: 'align-middle',
                    key: 'description',
                    label: this.$i18n.t('common.description')
                },
                { tdClass: 'align-middle', key: 'userId', label: 'Người tạo' },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions')
                }
            ],
            itemInfo: {
                code: '',
                configParams: {}
            },
            currentId: null,
            currentPage: 1,
            CONSTANTS
        };
    },
    methods: {
        ...mapActions({
            getList: 'station/getList',
            updateOrCreate: 'station/updateOrCreate',
            deleteById: 'station/delete',
            getInfo: 'station/getInfo',
            createAuditByUser: 'user/createAuditByUser',
            getListUsers: 'user/getListUsers'
        }),
        handleCreateOk(modal) {
            modal.preventDefault();
            this.onSubmit();
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    if (this.itemInfo.id) {
                        this.update();
                    } else {
                        this.add();
                    }
                    this.$refs.createOrUpdateModal.hide();
                    this.$toaster.success(
                        `${
                            this.itemInfo.id
                                ? this.$i18n.t('common.update')
                                : this.$i18n.t('common.create')
                        } trạm thành công`
                    );
                    this.createAuditByUser({
                        content: this.itemInfo.id ? 'Sửa thông tin trạm' : 'Tạo mới trạm'
                    });
                }
            });
        },
        async add() {
            delete this.itemInfo.id;
            await this.updateOrCreate(this.itemInfo);
        },
        async showUpdateModal(id) {
            this.resetForm();
            await this.getInfo({ id: id });
            this.itemInfo = _.cloneDeep(this.item);
            if (!this.itemInfo.configParams) this.itemInfo.configParams = {};
            if (this.itemInfo.configParams.warningLowWater)
                this.itemInfo.configParams.warningLowWater = parseFloat(
                    this.itemInfo.configParams.warningLowWater
                );
            if (this.itemInfo.warningLevel1)
                this.itemInfo.warningLevel1 = this.itemInfo.warningLevel1 / 100;
            if (this.itemInfo.warningLevel2)
                this.itemInfo.warningLevel2 = this.itemInfo.warningLevel2 / 100;
            if (this.itemInfo.warningLevel3)
                this.itemInfo.warningLevel3 = this.itemInfo.warningLevel3 / 100;
            if (this.itemInfo.configParams && this.itemInfo.configParams.warningLowWater)
                this.itemInfo.configParams.warningLowWater =
                    parseFloat(this.itemInfo.configParams.warningLowWater) / 100;
            this.$refs.createOrUpdateModal.show();
        },
        async update() {
            if (this.itemInfo.warningLevel1)
                this.itemInfo.warningLevel1 = this.itemInfo.warningLevel1 * 100;
            if (this.itemInfo.warningLevel2)
                this.itemInfo.warningLevel2 = this.itemInfo.warningLevel2 * 100;
            if (this.itemInfo.warningLevel3)
                this.itemInfo.warningLevel3 = this.itemInfo.warningLevel3 * 100;
            if (this.itemInfo.configParams && this.itemInfo.configParams.warningLowWater)
                this.itemInfo.configParams.warningLowWater =
                    this.itemInfo.configParams.warningLowWater * 100;
            await this.updateOrCreate(this.itemInfo);
        },
        async onDelete(modal) {
            modal.preventDefault();
            await this.deleteById({ id: this.currentId });
            if (this.items.length / this.CONSTANTS.ITEM_PER_PAGE === this.currentPage - 1) {
                this.currentPage--;
            }
            this.$refs.deleteModal.hide();
            this.$toaster.success('Xoá trạm thành công!');
            this.createAuditByUser({
                content: 'Xoá trạm'
            });
        },
        openCreateModal() {
            this.resetForm();
            this.$refs.createOrUpdateModal.show();
        },
        async confirmDelete(zoneId) {
            this.currentId = zoneId;
            this.$refs.deleteModal.show();
        },
        resetForm() {
            this.itemInfo = {
                code: '',
                configParams: {}
            };
        },
        stationScript(code) {
            if (!code) return;
            return code.includes('F01')
                ? `import requests \nurl = 'https://api.canhbaolu.bache.vn/api/nhanmucnuoc?matram=${code}&ngay=${this.$moment().format(
                      'DD/MM/YYYY'
                  )}&gio=${this.$moment().format('HH')}&phut=${this.$moment().format(
                      'mm'
                  )}&mucnuoc=3.2' \nresponse = requests.request('GET', url)'`
                : `import requests \nurl = 'https://api.canhbaolu.bache.vn/api/nhankqmua?matram=${code}&ngay=${this.$moment().format(
                      'DD/MM/YYYY'
                  )}&gio=${this.$moment().format('HH')}&phut=${this.$moment().format(
                      'mm'
                  )}&luongmua=0.9' \nresponse = requests.request('GET', url)'`;
        }
    }
};
</script>
